import createSubtitleFabric from "../../../general/CoreHeader/components/Subtitle/subtitleFabric";
import { createDisplayNameForHeaderClose } from "../../utils/createDisplayName";
import { createTestIdForHeaderClose } from "../../utils/createTestId";

const displayName = createDisplayNameForHeaderClose("Subtitle");
const testId = createTestIdForHeaderClose("subtitle");

const HeaderCloseSubtitle = createSubtitleFabric(displayName, testId);

export default HeaderCloseSubtitle;
